import { Plus, Minus, UtensilsCrossed } from "lucide-react";
import React, { useState } from "react";
import clsx from "clsx";
import { useCart } from "../context/CartContext";

const DishCard = ({ id, title, description, price, image, onViewDetails, cartQuantity = 0, avgRating, reviewCount }) => {
    const { addItem, increaseQuantity, decreaseQuantity } = useCart();
    const [popping, setPopping] = useState(false);
    const [imgError, setImgError] = useState(false);

    const haptic = (type = 'light') => window.Telegram?.WebApp?.HapticFeedback?.impactOccurred(type);

    const handleAdd = (e) => {
        e.stopPropagation();
        setPopping(true);
        setTimeout(() => setPopping(false), 300);
        haptic('light');
        addItem({ id, title, price, image });
    };

    const handleIncrease = (e) => {
        e.stopPropagation();
        haptic('light');
        increaseQuantity(id);
    };

    const handleDecrease = (e) => {
        e.stopPropagation();
        haptic('light');
        decreaseQuantity(id);
    };

    return (
        <div
            className="relative bg-white rounded-2xl border border-gray-200 shadow-sm active:scale-[0.98] transition-transform duration-150 overflow-hidden cursor-pointer flex flex-col"
            onClick={onViewDetails}
        >
            {/* Фото */}
            <div className="bg-gray-100 w-full aspect-[4/3] overflow-hidden relative">
                {!imgError && image ? (
                    <img
                        src={image}
                        alt={title}
                        className="w-full h-full object-cover"
                        onError={() => setImgError(true)}
                    />
                ) : (
                    <div className="w-full h-full flex items-center justify-center text-gray-300">
                        <UtensilsCrossed size={36} />
                    </div>
                )}

                {/* Бейдж «в корзине» */}
                {cartQuantity > 0 && (
                    <div className="absolute top-2 left-2 bg-brandBlue text-white text-[10px] font-semibold px-2 py-0.5 rounded-full shadow-sm">
                        {cartQuantity} в корзине
                    </div>
                )}
            </div>

            <div className="p-2.5 flex flex-col flex-1">
                <h3 className="text-xs font-semibold text-gray-900 leading-tight xs:text-sm">{title}</h3>
                <p className="text-[11px] xs:text-xs text-gray-500 mt-1 line-clamp-2 leading-relaxed flex-1">{description}</p>

                <div className="flex justify-between items-center mt-3">
                    <div>
                        <span className="text-base font-bold text-gray-900">{price} ₽</span>
                        {avgRating > 0 && (
                            <div className="flex items-center gap-1 mt-1">
                                <span className="text-amber-400 text-sm leading-none">★</span>
                                <span className="text-xs text-gray-700 font-semibold">{avgRating}</span>
                                {reviewCount > 0 && (
                                    <span className="text-xs text-gray-400">({reviewCount})</span>
                                )}
                            </div>
                        )}
                    </div>

                    {cartQuantity > 0 ? (
                        /* Степпер количества */
                        <div
                            className="flex items-center gap-1 bg-brandBlue/5 rounded-xl border border-brandBlue/20 p-0.5"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <button
                                onClick={handleDecrease}
                                className="w-7 h-7 flex items-center justify-center rounded-lg bg-white shadow-sm text-brandBlue hover:bg-red-50 hover:text-red-500 transition-colors"
                            >
                                <Minus size={13} strokeWidth={2.5} />
                            </button>
                            <span className="text-sm font-bold text-brandBlue min-w-[18px] text-center">
                                {cartQuantity}
                            </span>
                            <button
                                onClick={handleIncrease}
                                className="w-7 h-7 flex items-center justify-center rounded-lg bg-brandBlue text-white shadow-sm hover:bg-brandBlue/90 transition-colors"
                            >
                                <Plus size={13} strokeWidth={2.5} />
                            </button>
                        </div>
                    ) : (
                        /* Кнопка добавить */
                        <button
                            className={clsx(
                                "w-8 h-8 flex items-center justify-center rounded-full",
                                "bg-brandBlue text-white shadow-md",
                                "hover:bg-brandBlue/90 active:scale-90 transition-all duration-150",
                                popping && "cart-pop"
                            )}
                            onClick={handleAdd}
                        >
                            <Plus size={17} strokeWidth={2.5} />
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DishCard;
